<template>
  <div class="col">
    <!-- <h1>Esto es la home privada</h1> -->
  </div>
</template>

<script setup lang="ts"></script>
